import { gql } from '@apollo/client'

export default gql(`
    query listGenres($search: SearchInput $limit: Int $offset: Int $project: String){
        listGenre( 
            search: $search
            limit: $limit
            offset: $offset
            project: $project
        ) {
        items {
            id
            name
            source
            assetCount
        }
        totalCount
    }
}`)
